<script setup lang="ts">
import Toggle from '../Toggle.vue'
defineProps<{
  checked?: boolean
  truncate?: boolean
}>()

defineEmits<{
  click: [checked: boolean]
}>()
</script>
<template>
  <button
    class="focus:ring-secondary-200 hover:bg-neutral-light group relative flex min-h-9 w-full items-start justify-between rounded-md p-2 pr-4 ring-offset-2 outline-none focus:ring focus:ring-2"
    :class="{
      'text-neutral-900': !checked,
    }"
    type="button"
    @click="$emit('click', !checked)"
  >
    <div
      class="body-2 w-full max-w-prose flex-1 pt-0.5 text-left text-neutral-900"
      :class="{
        'truncate whitespace-nowrap': truncate,
      }"
    >
      <slot />
    </div>
    <Toggle :model-value="checked" />
  </button>
</template>
